module.exports = __webpack_public_path__ + "assets/icon_small_jdp.6a5546f5.svg";